import template from './card.html';
import controller from './card.controller';
import './card.scss';

let cardComponent = {
  bindings: {},
  template,
  controller
};

export default cardComponent;



// WEBPACK FOOTER //
// ./client/app/components/card/card.component.js